import { render, staticRenderFns } from "./AppAdd.vue?vue&type=template&id=6451fe46&scoped=true"
import script from "./AppAdd.vue?vue&type=script&lang=js"
export * from "./AppAdd.vue?vue&type=script&lang=js"
import style0 from "./AppAdd.vue?vue&type=style&index=0&id=6451fe46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6451fe46",
  null
  
)

export default component.exports